import { Header } from '@mairistem/composants';

import { formatMonetaire } from '@/utils';
import { ModalConfirm } from '../Autre';
import RelanceSummaryTile from './RelanceSummaryTile';
import RelanceTile from './RelanceTile';

type ModalConfirmRelancesProps = {
  loading: boolean;
  total: number;
  totalReste: number;
  nombreRelances: number;
  nombreMailsPotentiel: number;
  nombreFacturesMails: number;
  onCancel: () => void;
  onConfirm: () => void;
};

const ModalConfirmRelances = (props: ModalConfirmRelancesProps) => {
  const {
    loading,
    total,
    totalReste,
    nombreRelances,
    nombreMailsPotentiel,
    nombreFacturesMails,
    onCancel,
    onConfirm,
  } = props;

  // Calculs pour les relances courrier
  const nombreRelancesCourrier = nombreRelances - nombreMailsPotentiel;
  const nombreFacturesCourrier = total - nombreFacturesMails;

  // Vérifier s'il n'y a qu'une seule tuile affichée
  const hasOnlyOneTile =
    (nombreMailsPotentiel > 0 && nombreRelancesCourrier === 0) ||
    (nombreMailsPotentiel === 0 && nombreRelancesCourrier > 0);

  return (
    <ModalConfirm
      loading={loading}
      header="Générer des relances"
      size="tiny"
      content={
        <>
          <RelanceSummaryTile
            relancesCount={nombreRelances}
            montantTotal={formatMonetaire(totalReste, 2, true)}
            fullWidth={!hasOnlyOneTile}
          />

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              columnGap: '1em',
              marginBottom: '2em',
            }}
          >
            {nombreMailsPotentiel > 0 && (
              <RelanceTile
                icon={{ name: 'Send' }}
                label="par mail"
                relancesCount={nombreMailsPotentiel}
                facturesCount={nombreFacturesMails}
                isMail
                showOnlyTile={hasOnlyOneTile}
              />
            )}
            {nombreRelancesCourrier > 0 && (
              <RelanceTile
                icon={{ name: 'Mail' }}
                label="par courrier"
                relancesCount={nombreRelancesCourrier}
                facturesCount={nombreFacturesCourrier}
                showOnlyTile={hasOnlyOneTile}
              />
            )}
          </div>

          <Header as="h5" style={{ textAlign: 'center', margin: 0 }}>
            <Header.Content>Êtes-vous sûr de vouloir effectuer cette action ?</Header.Content>
          </Header>
        </>
      }
      cancelText="Annuler"
      confirmText="Confirmer la génération"
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
};

export default ModalConfirmRelances;
